import { useNotificationStore } from '../store/notification-store'

type NotificationMethod = (message: string, config?: { group?: string, timeout?: number }) => void
type NotificationErrorMethod = (message: string | Error | unknown, config?: { group?: string, timeout?: number }) => void

export function useNotifications(): { info: NotificationMethod, warning: NotificationMethod, success: NotificationMethod, error: NotificationErrorMethod } {
  return useNotificationStore()
}
